import { Button } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import HeaderDialog from 'components/foundation/dialogs/HeaderDialog/HeaderDialog';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';

export interface IUnpairTrackingDeviceDialogProps {
  className?: ClassName;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const UnpairTrackingDeviceDialog = (props: IUnpairTrackingDeviceDialogProps) => {
  const { className, isOpen, onClose, onSubmit } = props;

  const classes = classNames('unpair-tracking-device-dialog', className);

  return (
    <HeaderDialog className={classes} title={t('Unpair Tracking Device')} isOpen={isOpen} onClose={onClose}>
      <div className={'m-4'}>
        <div>
          {t(
            'Future data won’t be linked to this equipment. If you’re transferring this device, we recommend you cancel and assign it to the new equipment first so you can set the correct installation time.'
          )}
        </div>
        <Button className="mt-4 mr-2" type="primary" onClick={onSubmit}>
          {t('Unpair')}
        </Button>
        <Button className="mt-4" type="secondary" onClick={onClose}>
          {t('Cancel')}
        </Button>
      </div>
    </HeaderDialog>
  );
};

export default UnpairTrackingDeviceDialog;
